import { useOffersRound } from '../../../../../app/contexts/offers-round/offers-round.context';
import Position from '../../../../../common/enums/position';
import PositionSection from '../position-section/position-section';
import './offers-list-by-position.scss';

export default function OffersListByPosition() {
    const {
        confirmationOffersList,
        confirmationHasMore,
        fetchNextPageByPosition,
        confirmationErrors,
        isConfirmationAvailable,
        roundState,
    } = useOffersRound();

    return (
        <div
            className="offers-list-by-position"
            data-testid="offers-list-by-position"
        >
            <PositionSection
                position={Position.First}
                offersList={confirmationOffersList[Position.First]}
                hasMore={confirmationHasMore.current[Position.First]}
                onFetchMore={() => fetchNextPageByPosition(Position.First)}
                currentError={confirmationErrors[Position.First]}
                confirmationBeginningTime={new Date(0)}
                isConfirmationAvailable
            />

            <PositionSection
                position={Position.Second}
                offersList={confirmationOffersList[Position.Second]}
                hasMore={confirmationHasMore.current[Position.Second]}
                onFetchMore={() => fetchNextPageByPosition(Position.Second)}
                currentError={confirmationErrors[Position.Second]}
                confirmationBeginningTime={
                    roundState.confirmation2ndBeginningTime
                }
                isConfirmationAvailable={
                    isConfirmationAvailable[Position.Second]
                }
            />

            <PositionSection
                position={Position.Third}
                offersList={confirmationOffersList[Position.Third]}
                hasMore={confirmationHasMore.current[Position.Third]}
                onFetchMore={() => fetchNextPageByPosition(Position.Third)}
                currentError={confirmationErrors[Position.Third]}
                confirmationBeginningTime={
                    roundState.confirmation3rdBeginningTime
                }
                isConfirmationAvailable={
                    isConfirmationAvailable[Position.Third]
                }
            />
        </div>
    );
}
